import { HTTP_TOKEN } from "./http";

export const getDomains = params => {
  return HTTP_TOKEN.get("domain", { params }).then(result => {
    return result.data;
  });
};

export const createDomain = data => {
  return HTTP_TOKEN.post("domain", data).then(result => {
    return result.data;
  });
};


export const deleteDomain = (domainId) => {
  return HTTP_TOKEN.delete(`domain/${domainId}`).then(result => {
    return result.data;
  });
};


export const updateDomain = (domainId, data) => {
  return HTTP_TOKEN.put(`domain/${domainId}`, data).then(result => {
    return result.data;
  });
};

export const checkDomainDns = (domainId) => {
  return HTTP_TOKEN.get(`domain/${domainId}/check`, {}).then(result => {
    return result.data;
  });
};

